'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var ReactDOM = _interopRequireWildcard(_reactDom);

var _rcTabs = require('rc-tabs');

var _rcTabs2 = _interopRequireDefault(_rcTabs);

var _rcTabsLibScrollableInkTabBar = require('rc-tabs/lib/ScrollableInkTabBar');

var _rcTabsLibScrollableInkTabBar2 = _interopRequireDefault(_rcTabsLibScrollableInkTabBar);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var Tabs = (function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs(props) {
    _classCallCheck(this, Tabs);

    _get(Object.getPrototypeOf(Tabs.prototype), 'constructor', this).call(this, props);
  }

  _createClass(Tabs, [{
    key: 'handleChange',
    value: function handleChange(activeKey) {
      var onChange = this.props.onChange;
      if (onChange) {
        onChange(activeKey);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props;
      var prefixCls = _props.prefixCls;
      var _props$className = _props.className;
      var className = _props$className === undefined ? '' : _props$className;
      var size = _props.size;
      var _props$type = _props.type;
      var type = _props$type === undefined ? 'line' : _props$type;
      var tabPosition = _props.tabPosition;
      var children = _props.children;
      var tabBarExtraContent = _props.tabBarExtraContent;
      var tabBarStyle = _props.tabBarStyle;
      var hideAdd = _props.hideAdd;
      var onTabClick = _props.onTabClick;
      var onPrevClick = _props.onPrevClick;
      var onNextClick = _props.onNextClick;
      var _props$animated = _props.animated;
      var animated = _props$animated === undefined ? false : _props$animated;
      var tabBarGutter = _props.tabBarGutter;

      var _ref = typeof animated === 'object' ? {
        inkBarAnimated: animated.inkBar, tabPaneAnimated: animated.tabPane
      } : {
        inkBarAnimated: animated, tabPaneAnimated: animated
      };

      var inkBarAnimated = _ref.inkBarAnimated;
      var tabPaneAnimated = _ref.tabPaneAnimated;

      // card tabs should not have animation
      if (type !== 'line') {
        tabPaneAnimated = 'animated' in this.props ? tabPaneAnimated : false;
      }

      var cls = (0, _classnames2['default'])(className, (_classNames = {}, _defineProperty(_classNames, prefixCls + '-vertical', tabPosition === 'left' || tabPosition === 'right'), _defineProperty(_classNames, prefixCls + '-' + size, !!size), _defineProperty(_classNames, prefixCls + '-card', type.indexOf('card') >= 0), _defineProperty(_classNames, prefixCls + '-' + type, true), _defineProperty(_classNames, prefixCls + '-no-animation', !tabPaneAnimated), _classNames));

      tabBarExtraContent = tabBarExtraContent ? _react2['default'].createElement(
        'div',
        { className: prefixCls + '-extra-content' },
        tabBarExtraContent
      ) : null;

      var renderTabBar = function renderTabBar() {
        return _react2['default'].createElement(_rcTabsLibScrollableInkTabBar2['default'], {
          inkBarAnimated: inkBarAnimated,
          extraContent: tabBarExtraContent,
          onTabClick: onTabClick,
          onPrevClick: onPrevClick,
          onNextClick: onNextClick,
          style: tabBarStyle,
          tabBarGutter: tabBarGutter
        });
      };

      return _react2['default'].createElement(
        _rcTabs2['default'],
        _extends({}, this.props, {
          className: cls,
          tabBarPosition: tabPosition,
          renderTabBar: renderTabBar,
          renderTabContent: function () {
            return _react2['default'].createElement(_rcTabs.TabContent, { animated: tabPaneAnimated, animatedWithMargin: true });
          },
          onChange: this.handleChange.bind(this)
        }),
        children
      );
    }
  }]);

  return Tabs;
})(_react2['default'].Component);

Tabs.defaultProps = {
  prefixCls: 'Tabs',
  hideAdd: false
};

module.exports = Tabs;
module.exports.TabPane = _rcTabs.TabPane;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/Tabs.js
// module id = 340
// module chunks = 0